import React from 'react';
import PropTypes from 'prop-types';

import './Pricing.sass';

import cx from 'classnames';

import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

export default function Pricing({ value, originalValue, channel, annotation, accented, between, small }) {
  return (
    <span
      className={cx(
        'pricing',
        accented && 'pricing--accented',
        between && 'pricing--between',
        small && 'pricing--small'
      )}
    >
      <span className="pricing__value">
        {annotation}
        {annotation && ' '}
        <ChannelPrice channel={channel} price={value} />
      </span>
      {originalValue && <ChannelPrice className="pricing__original" channel={channel} price={originalValue} />}
    </span>
  );
}

Pricing.propTypes = {
  value: PropTypes.number.isRequired,
  originalValue: PropTypes.number,
  channel: PropTypes.string,
  annotation: PropTypes.node,
  accented: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./components/pricing/Pricing.js